import React from 'react';
import { Link } from 'react-router-dom';

const ProjectCard = ({ project }) => {
    return (
        <article className="project-card" data-scroll-reveal>
            <div className="project-image">
                <div className="project-image-wrapper">
                    <div className={`project-placeholder ${project.className}`}></div>
                </div>
                <div className="project-overlay">
                    <Link to={`/work#${project.id}`} className="project-link">View Project</Link>
                </div>
            </div>
            <div className="project-info">
                <div className="project-meta">
                    <span className="project-category">{project.category}</span>
                    <span className="project-year">{project.year}</span>
                </div>
                <h3 className="project-title">{project.title}</h3>
                <p className="project-description">{project.description}</p>
                <div className="project-tags">
                    {project.tags.map((tag, index) => (
                        <span key={index} className="tag">{tag}</span>
                    ))}
                </div>
            </div>
        </article>
    );
};

export default ProjectCard;
